<div class="walletWrapper p-3">
    <p-toolbar styleClass="border-none pb-2" *ngIf="filteredWalletElements.length > 10">
        <div class="flex flex-1 justify-content-between">
            <div class="flex-1 pb-2">
                <span class="p-input-icon-left w-full">
                    <i class="ml-1 far fa-magnifying-glass"></i>
                    <input type="text" class="w-full" pInputText id="searchBar"  [(ngModel)]="searchInput" (keyup)="onFilterInput()"/>
                </span>
            </div>
        </div>
    </p-toolbar>

    <ng-container *ngIf="filteredWalletElements">
        <div class="walletItem flex align-items-center mb-2" *ngFor="let walletElement of filteredWalletElements" (click)="onWalletElementClicked(walletElement)">
            <img [src]="walletElement.product.image?.url" [alt]="walletElement.product.name" class="walletBildKlein" />
            <div class="walletTitle">
                <div class="font-bold">{{ walletElement.product.name }}</div>
            </div>
        </div>
    </ng-container>

    <div class="px-4 pt-3 text-center font-semibold" i18n="@@payment-wallet.disclamer">Your purchased products that you have not yet redeemed are displayed here.</div>

</div>

<p-dialog [focusOnShow]="false" header="{{ selectedWalletElement.product.name }}"  position="center" [modal]="true"
          [(visible)]="dialogControl.showProductDetails" *ngIf="dialogControl.showProductDetails" [draggable]="false" [resizable]="false">
    <div class="surface-border border-round surface-card mb-5">
        <div class="flex justify-content-center">
            <div class="walletBild">
                <img
                    [src]="selectedWalletElement.product.image?.url"
                    [alt]="selectedWalletElement.product.name"
                    class="w-full" />
            </div>
        </div>

        <div class="flex flex-row justify-content-between p-3 pb-0">
            <div class="font-semibold" style="word-break: break-all;" i18n="@@payment-wallet.price">Price</div>

            <div class="font-semibold" style="word-break: break-all;">
                {{selectedWalletElement.product.price.amount / 100 | currency: selectedWalletElement.product.price.currency | uppercase}}
            </div>
        </div>
        <div class="p-3">
            {{ selectedWalletElement.product.description }}
        </div>


    </div>


    <div class="footer">
        <div *ngIf="selectedWalletElement.product.type == 'SINGLE_TICKET'" i18n="@@payment-wallet.singleTicket">
                One time usage
            </div>

            <div *ngIf="selectedWalletElement.product.type == 'MULTI_TICKET'" i18n="@@payment-wallet.multiTicket">
               MultiTicket: {{ selectedWalletElement.usageCount }} of {{ selectedWalletElement.usageLimit }} times used
            </div>

            <!--Laut stefan: überflüssige info-->
            <!-- <div *ngIf="selectedWalletElement.product.type == 'SEASON_TICKET'" i18n="@@payment-wallet.seasonTicket">
                Unlimited uses
            </div> -->

            <div *ngIf="selectedWalletElement.validFrom || selectedWalletElement.validTo">
                <span i18n="@@payment-wallet.valid">Valid </span><span *ngIf="selectedWalletElement.validFrom" i18n="@@payment-wallet.validFrom"> from </span> {{ selectedWalletElement.validFrom | date:"shortDate"}} <span *ngIf="selectedWalletElement.validTo" i18n="@@payment-wallet.validTo">to</span> {{ selectedWalletElement.validTo | date:"shortDate"}}
        </div>
    </div>

</p-dialog>


